import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Typography } from "antd";
import clsx from "clsx";
import { FC } from "react";

const Loading: FC<{
  text?: string;
  size: "fit" | "fill" | "screen";
  spinnerClassName?: string;
  textClassName?: string;
}> = ({
  text,
  size = "fill",
  spinnerClassName = "",
  textClassName = "",
}) => {
  return (
    <div
      className={clsx("flex flex-col items-center justify-center ", {
        "w-full h-full": size === "fill",
        "w-fit h-fit": size === "fit",
        "w-screen h-screen": size === "screen",
      })}
    >
      <Spin indicator={<LoadingOutlined className={spinnerClassName} spin />} size="large" />
      {text && (
        <Typography.Title
          style={{ direction: "rtl" }}
          level={5}
          className={clsx("text-center", textClassName)}
        >
          {text}
        </Typography.Title>
      )}
    </div>
  );
};

export default Loading;
